import { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import 'react-big-calendar/lib/css/react-big-calendar.css';

const BASE_URL = "https://partyhousedatabase-rpft.onrender.com";
const localizer = momentLocalizer(moment);

export default function AdminBookingCalendar() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = async () => {
    try {
      const res = await fetch(`${BASE_URL}/bookings/all`);
      const data = await res.json();
      setBookings(data);
    } catch (err) {
      alert("Failed to load bookings");
    }
    setLoading(false);
  };

  const updateStatus = async (id) => {
    const confirmUpdate = window.confirm("Mark this booking as CONFIRMED?");
    if (!confirmUpdate) return;

    try {
      const res = await fetch(`${BASE_URL}/bookings/status/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status: "Confirmed" }),
      });
      const result = await res.json();
      if (res.ok) {
        alert("Booking confirmed & email sent!");
        fetchBookings();
      } else {
        alert(result.error);
      }
    } catch (error) {
      alert("Server error");
    }
  };

  if (loading) return <h2 style={{ textAlign: "center" }}>Loading calendar...</h2>;

  // Map bookings to calendar events
  const events = bookings.map(b => ({
    id: b.id,
    title: `${b.name} (${b.status})`,
    start: new Date(b.event_date),
    end: new Date(b.event_date),
  }));

  return (
    <div style={{ padding: "40px", fontFamily: "'Segoe UI', sans-serif" }}>
      <h1 style={{ textAlign: "center", marginBottom: "30px", fontSize: "32px" }}>
        Booking Calendar
      </h1>

      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 600, margin: "0 auto", maxWidth: "900px" }}
        onSelectEvent={(event) => updateStatus(event.id)}
        tooltipAccessor={(event) => `Guests: ${bookings.find(b => b.id === event.id)?.guests || "-"}`}
      />
    </div>
  );
}
